import type { Command } from 'commander';
import { isConfigKey, isDeprecatedConfigKey, loadConfig, saveConfig, validateAndCoerce } from '../../lib/config-store';
import { CliError, ExitCode } from '../../lib/errors';
import { API_BASE_ENV_VAR } from '../../lib/global-opts';

export function registerConfigSet(parent: Command): void {
	parent
		.command('set <key> <value>')
		.description('Set a config value. Keys: locale, output, timeout_ms')
		.action((key: string, value: string) => {
			if (isDeprecatedConfigKey(key)) {
				throw new CliError(
					`Config key "${key}" was removed in 0.1.2. Set the ${API_BASE_ENV_VAR} env var ` +
						`(or use the --api flag) instead.`,
					ExitCode.InvalidArgument
				);
			}
			if (!isConfigKey(key)) {
				throw new CliError(
					`Unknown config key "${key}". Allowed: locale, output, timeout_ms`,
					ExitCode.InvalidArgument
				);
			}
			const coerced = validateAndCoerce(key, value);
			const config = loadConfig();
			// Object.assign 形式避免 TS 5.5 在 `config[key] = coerced` 上推不出
			// ConfigValueMap[K]→CliConfig[K] 的對應；validateAndCoerce 已 generic、型別正確。
			Object.assign(config, { [key]: coerced });
			saveConfig(config);
			process.stdout.write(`Set ${key} = ${JSON.stringify(coerced)}\n`);
		});
}
